import { render } from "./Index.vue?vue&type=template&id=c3e6f47e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script